interface IWorkerMsg {
  visibleParticipants?: number
  isWaitingRoom?: boolean
  hasClosedPopup?: boolean
  leftTime?: number
}

const worker = () => {
  let timerBeforeShowPopupId: NodeJS.Timeout | null = null
  let timerBeforeCloseRoomId: NodeJS.Timeout | null = null
  let intervalId: NodeJS.Timeout | null = null
  let intervalBeforePopupId: NodeJS.Timeout | null = null

  let secondsBeforeShowPopup: number = 60
  let secondsBeforeCloseRoom: number = 60

  let isPopupOpen: boolean = false
  let isAlone: boolean = false

  function sendLeftTime(sec: number) {
    let leftTime = new Date(sec * 1000).toISOString().substring(14, 19).padStart(5, '0')
    self.postMessage({ leftTime })
  }

  function resetAll() {
    if (timerBeforeShowPopupId) clearTimeout(timerBeforeShowPopupId)
    if (timerBeforeCloseRoomId) clearTimeout(timerBeforeCloseRoomId)
    if (intervalId) clearInterval(intervalId)
    if (intervalBeforePopupId) clearInterval(intervalBeforePopupId)

    timerBeforeShowPopupId = null
    timerBeforeCloseRoomId = null
    intervalId = null
    intervalBeforePopupId = null
    isPopupOpen = false
    secondsBeforeShowPopup = 60
    secondsBeforeCloseRoom = 60
    sendLeftTime(60)
    self.postMessage({ isOpen: false })
  }

  function startPopupDelay(isWaitingRoom: boolean) {
    if (timerBeforeShowPopupId) return
    secondsBeforeShowPopup = 60
    sendLeftTime(secondsBeforeShowPopup)
    intervalBeforePopupId = setInterval(() => {
      if (secondsBeforeShowPopup > 0) {
        secondsBeforeShowPopup--
        sendLeftTime(secondsBeforeShowPopup)
      }
    }, 1000)
    timerBeforeShowPopupId = setTimeout(() => {
      clearInterval(intervalBeforePopupId)
      intervalBeforePopupId = null
      if (!isWaitingRoom && isAlone) {
        isPopupOpen = true
        self.postMessage({ isOpen: true })
        startAutokickTimer()
      }
    }, 60 * 1000 * 5)
  }

  function startAutokickTimer() {
    secondsBeforeCloseRoom = 60
    sendLeftTime(secondsBeforeCloseRoom)
    intervalId = setInterval(() => {
      if (secondsBeforeCloseRoom > 0) {
        secondsBeforeCloseRoom--
        sendLeftTime(secondsBeforeCloseRoom)
      }
    }, 1000)
    timerBeforeCloseRoomId = setTimeout(() => {
      clearInterval(intervalId)
      intervalId = null
      self.postMessage({ closeRoom: true })
    }, 60 * 1000)
  }

  self.onmessage = (e: MessageEvent<IWorkerMsg>) => {
    if (e?.data?.visibleParticipants <= 1) {
      if (!isAlone) {
        // Переход в одиночество: сбрасываем все, стартуем ожидание
        isAlone = true
        resetAll()
        startPopupDelay(e?.data?.isWaitingRoom)
      }
      // Если уже одиночество, не делаем ничего (пусть таймер работает)
    } else {
      if (isAlone) {
        // Появился второй человек: сбрасываем все
        isAlone = false
        resetAll()
      }
    }

    // Пользователь нажал "Остаться"
    if (e?.data?.hasClosedPopup) {
      if (isPopupOpen && isAlone) {
        resetAll()
        startPopupDelay(false)
      }
    }
  }

  self.onmessageerror = () => {}
}

let code = worker.toString()
code = code.substring(code.indexOf('{') + 1, code.lastIndexOf('}'))

const blob = new Blob([code], { type: 'application/javascript' })
export const closeRoomPopupWorkerScript = URL.createObjectURL(blob)
